'use client';

import BaseInput, { type BaseInputProps } from '@/app/_components/base/input';
import { cn } from '@/app/lib/utils/tailwindcss';

export type InputProps = BaseInputProps;

export default function Input({ className, ...props }: InputProps) {
  return (
    <BaseInput
      className={cn(
        // Size & Layout
        'h-11 w-full rounded-lg px-4 py-3',
        // Typography
        'typo-body-5',
        // Default State
        'bg-input-default-bg border border-input-default-border text-input-default-text',
        'placeholder:text-input-default-text/50',
        // Focus State
        'focus:bg-input-focused-bg focus:border-input-focused-border focus:text-input-focused-text focus:outline-none',
        // Disabled State
        'disabled:bg-input-disabled-bg disabled:border-input-disabled-border disabled:text-input-disabled-text disabled:cursor-not-allowed',
        className,
      )}
      {...props}
    />
  );
}
